import React from "react";
import { OptionsFilter } from "../../../@types";
import { AlertCCT } from "../../../components/AlertCCT";
import { Tab } from "../../../components/Tab";
import { useOrderPages } from "../../../hook/useOrdersPage";
import { Container } from "../styles";
import { ListClientsOrder } from "./list-clients-order";
import { ListOrders } from "./list-orders";
import { ListOrdersItems } from "./list-orders-items";

interface IHeaderProps {
  admin?: boolean;
  seller?: boolean;
  client?: boolean;

  is_manager?: boolean;
  is_supervisor?: boolean;
}

export interface IFilterOption {
  status: OptionsFilter[];
  brands: OptionsFilter[];
  pointeds: OptionsFilter[];
  refuses: OptionsFilter[];
  sellers: OptionsFilter[];
}

const PanelOrder: React.FC<IHeaderProps> = ({ admin, client, seller }) => {
  const { tab, setTab } = useOrderPages();

  return (
    <Container>
      {client && <AlertCCT />}

      <Tab
        currentTab={tab}
        setTab={setTab}
        tabs={[
          {
            description: "Todos",
            component: (
              <ListOrders admin={admin} client={client} seller={seller} />
            ),
          },
          {
            description: "Itens cancelados",
            component: (
              <ListOrdersItems admin={admin} client={client} seller={seller} />
            ),
          },
          {
            description: "Faturados",
            component: (
              <ListOrders admin={admin} client={client} seller={seller} />
            ),
          },
          {
            description: "Itens em aberto",
            component: (
              <ListOrdersItems admin={admin} client={client} seller={seller} />
            ),
          },
          {
            description: "Oportunidade de regularização",
            component: (
              <ListClientsOrder admin={admin} client={client} seller={seller} />
            ),
          },
          // { description: "itens devolvidos (itens dos livros)", component: <></> },
        ].filter((f) =>
          client ? f.description !== "Oportunidade de regularização" : true
        )}
      />
    </Container>
  );
};

export default PanelOrder;
